if (!String.prototype.contains) {
    String.prototype.contains = function (item, caseSensitive) {
        if (typeof caseSensitive === "undefined") {
            caseSensitive = true;
        }

        if (caseSensitive) {
            return this.indexOf(item) != -1;
        }

        return this.toLowerCase().indexOf(item.toLowerCase()) != -1;
    }
}


//////////////////
// WEBPACK FOOTER
// ./src/app/extensions/string.js
// module id = 437
// module chunks = 1